import { render, staticRenderFns } from "./EconomyOverview.vue?vue&type=template&id=7fe83148&scoped=true&lang=html&"
import script from "./EconomyOverview.vue?vue&type=script&lang=js&"
export * from "./EconomyOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe83148",
  null
  
)

export default component.exports